(function () {
  'use strict';

  var HEIGHTS_IN = [61, 63, 65, 67, 69];
  var WEIGHTS_LB = [88, 94, 99, 105, 110, 116, 121, 127, 132, 138, 143, 149];
  var SIZES = ['S (4)', 'M (6)', 'L (8)', 'XL (10)'];
  var RECOMMENDATIONS = [
    [0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3],
    [0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3],
    [0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3],
    [0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 3, 3],
    [0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3]
  ];

  function nearestIndex(value, values) {
    for (var i = 0; i < values.length - 1; i += 1) {
      if (value < (values[i] + values[i + 1]) / 2) return i;
    }
    return values.length - 1;
  }

  function recommend(feet, inches, pounds) {
    var hasInches = inches !== null && inches !== undefined;
    if (!Number.isFinite(feet) || feet <= 0 || !Number.isFinite(pounds) || (hasInches && (!Number.isInteger(inches) || inches < 0 || inches > 11))) {
      return { error: 'Enter a valid height and weight.' };
    }
    if (!Number.isInteger(feet) && hasInches) {
      return { error: 'Use decimal feet on its own, or whole feet with inches.' };
    }
    var heightInches = feet * 12 + (hasInches ? inches : 0);
    if (heightInches < 60.9 || heightInches > 69.1 || pounds < 88 || pounds > 149) {
      return { error: 'This guide covers heights from 5 ft 1 in to 5 ft 9 in and weights from 88 to 149 lb. Compare the garment measurements above for other sizes.' };
    }
    var heightIndex = nearestIndex(heightInches, HEIGHTS_IN);
    var weightIndex = nearestIndex(pounds, WEIGHTS_LB);
    var roundedHeight = Math.round(heightInches);
    return {
      size: SIZES[RECOMMENDATIONS[heightIndex][weightIndex]],
      height: Math.floor(roundedHeight / 12) + ' ft ' + (roundedHeight % 12) + ' in'
    };
  }

  function mount(root) {
    root.className = 'pf-size-finder';
    root.innerHTML =
      '<h4 class="pf-size-finder__title">Find your size</h4>' +
      '<p class="pf-size-finder__intro">Enter decimal feet (5.5 ft = 5 ft 6 in), or whole feet plus inches. Leave inches blank when using decimal feet.</p>' +
      '<div class="pf-size-finder__fields">' +
        '<label>Height <span>ft</span><input class="pf-size-finder__feet" type="number" min="5" max="6" step="any" inputmode="decimal" placeholder="5.5" autocomplete="off"></label>' +
        '<label>Height <span>in</span><input class="pf-size-finder__inches" type="number" min="0" max="11" step="1" inputmode="numeric" placeholder="Optional" autocomplete="off"></label>' +
        '<label>Weight <span>lb</span><input class="pf-size-finder__weight" type="number" min="88" max="149" step="0.1" inputmode="decimal" placeholder="121" autocomplete="off"></label>' +
      '</div>' +
      '<button type="button" class="pf-size-finder__button">Find my size</button>' +
      '<p class="pf-size-finder__result" role="status" aria-live="polite"></p>' +
      '<p class="pf-size-finder__note">This height and weight guide covers S–XL. For XS or a closer fit check, use the garment measurements above.</p>';

    root.querySelector('.pf-size-finder__button').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var feetValue = root.querySelector('.pf-size-finder__feet').value.trim();
      var inchesValue = root.querySelector('.pf-size-finder__inches').value.trim();
      var weightValue = root.querySelector('.pf-size-finder__weight').value.trim();
      var resultNode = root.querySelector('.pf-size-finder__result');
      var result = feetValue && weightValue
        ? recommend(Number(feetValue), inchesValue ? Number(inchesValue) : null, Number(weightValue))
        : { error: 'Enter your height and weight to see a size suggestion.' };
      resultNode.textContent = result.error || ('Suggested size: ' + result.size + ' · Height entered: ' + result.height);
      resultNode.classList.toggle('pf-size-finder__result--error', Boolean(result.error));
    });
  }

  if (typeof window !== 'undefined') window.PipedFormSizeFinder = { recommend: recommend };
  if (typeof document !== 'undefined') {
    var root = document.getElementById('pipedform-size-finder');
    if (root) mount(root);
  }
}());
